import { createContext } from 'react';

const ReviewAlertEditorContext = createContext(null);

export default ReviewAlertEditorContext;
